import { Table } from 'appkit-react';

const DataQualityTable = ({
    dataQualityStatusColumns, ruleSummaryData,
}) => (
    <div style={{ margin: '0.1rem' }}>
        <Table
            data={ruleSummaryData}
            columns={dataQualityStatusColumns}
            showPagination
            defaultPageSize={10}
            sortable
            resizable
            noDataText="No Data ..!!!"
        />
    </div>
);

export default DataQualityTable;
